import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'hb-password-reset-dialog',
  templateUrl: './password-reset-dialog.component.html',
})
export class PasswordResetDialogComponent implements OnInit {
  public okDisabled: boolean;

  constructor(public bsModalRef: BsModalRef) { }

  public ngOnInit() { }

  public setOkDisabled(value: boolean) {
    this.okDisabled = value;
  }
}
